import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`

* {
    font-family: "ABeeZee", Helvetica, sans-serif;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    background-color: #8783d1;
}

`

export default GlobalStyle